<template>
  <div ref="ai-feedback-modal" class="app-modal-dialog--ai-feedback app-modal-dialog modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="app-modal-dialog__content modal-dialog">
      <div class="app-modal-dialog__header">
        <div class="app-modal-dialog__titles">
          <h2 class="app-modal-dialog__title">Provide AI Feedback</h2>
        </div>
      </div>
      <form class="ai-console" enctype="multipart/form-data" @submit.prevent="save">
        <div class="app-modal-dialog__body grid">
          <div class="col-12">
            <p class="app-modal-dialog__section-instructions">Please do not enter any unnecessary personal information or any sensitive personal data (including government identifiers such as tax file numbers or social security numbers), client confidential information, audit secrets, state secrets, commercial secrets, or anything that would violate professional secrecy or confidentiality rules or that would be considered abusive/irrelevant.</p>
          </div>
          <div v-if="hasErrors" class="col-12">
            <AppError 
            v-if="hasErrors"
            class="is--inline"
            v-bind="{ errors, message: errorMessage }" 
            />
          </div>
          <div class="app-toast is--success alert" role="alert" v-if="message">
            <div class="app-toast__text">
              <p class="app-toast__title">{{ message }}</p>
            </div>
            <button type="button" class="app-toast__close element-button--icon element-button" data-bs-dismiss="alert" aria-label="Close">
                <svg aria-hidden="true" class="element-icon--x element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-x"></use></svg>
            </button>
          </div>
          <div class="col-12">
            <div class="input select">
              <label for="feedback_type">Please select any issues you have experienced while using this tool</label>
              <select
                class="form-control"
                name="feedback_type"
                id="feedback_type"
                v-model="selectedFeedbackType"
                required>
                <option value="" disabled>Select an issue</option>
                <option v-for="type in feedbackTypes" :key="type.label" :value="type.label">
                  {{ type.label }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-12">
            <div class="input textarea">
              <label for="feedback_message">Please describe the issue in detail</label>
              <textarea
                rows="5"
                v-model="feedback_message"
                name="feedback_message"
                id="feedback_message"
                ref="input"
                required>
              </textarea>
            </div>
          </div>
          <div class="col-12">
            <div class="inputfile__wrapper">
              <p class="inputfile__label">Media (optional)</p>
              <div class="input inputfile">
                <label for="feedback_screenshot_file" class="inputfile__choose-file">
                  <div class="inputfile__instructions">
                    <span class="inputfile__instructions-action">Click to upload</span>
                    or drag and drop
                  </div>
                <input
                  class="input file"
                  type="file"
                  id="feedback_screenshot_file"
                  name="feedback_screenshot_file"
                  :accept="extensions"
                  ref="fileInput"
                />
                </label>
                <p class="inputfile__filetypes">{{ validExtensions.join(', ') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="app-modal-dialog__footer">
          <button 
            type="button" 
            class="element-button--secondary element-button" 
            data-bs-dismiss="modal" 
            aria-label="Close">
            Cancel
          </button>
          <button
            :disabled="isSaving"
            type="submit"
            class="element-button--primary element-button">
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import api from '../api/ai'
import AppError from './AppError.vue';

export default {
  components: {
    AppError
  },
  props: {
    feedbackTypes: {
      type: Array,
      default: () => []
    },
    validExtensions: {
      type: Array,
      default: () => ['*']
    }
  },
  data () {
    return {
      selectedFeedbackType: '',
      feedback_message: '',
      isSaving: false,
      hasErrors: false,
      errorMessage: null,
      message: null,
      errors: null
    }
  },
  computed: {
    extensions () {
      return this.validExtensions.join(',')
    },
  },
  methods: {
    close () {
      this.message = null;
      this.errors = null;
      const modal = this.$refs['ai-feedback-modal'];
      if (modal) {
        modal.querySelector('[data-bs-dismiss="modal"]').click()
      }
      // TODO: need to properly call .hide() function on the modal instance, the below code is not the right way to do it
      return
    },
    async save () {
      this.errors = null;
      const formData = new FormData();
      const fileInput = this.$refs.fileInput;
      const details = {
        url: window.location.href,
        metadata: window._aiMetadata || null
      }
      
      formData.append('feedback_details', JSON.stringify(details));
      formData.append('feedback_type', this.selectedFeedbackType);
      formData.append('feedback_message', this.feedback_message);

      if (fileInput && fileInput.files && fileInput.files[0]) {
        formData.append('feedback_screenshot_file', fileInput.files[0]);
      }

      this.isSaving = true;
      let result = await api.storeAiFeedback(formData);

      if (result && result.errors) {
        this.errors = result.errors
        this.hasErrors = true;
      } else if (result) {
        this.message = 'Feedback submitted successfully!';
        this.hasErrors = false;
        this.selectedFeedbackType = '';
        this.feedback_message = '';
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = '';
        }
        this.isSaving = true
        setTimeout(() => {
          this.close();
          this.isSaving = false
        }, 2000);
        return
      } else {
        alert('Please try again later.');
      }
      this.isSaving = false;
    }
  }
}
</script>
